import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const SessionConfirmationModal = (props) => {
  const history = useHistory();
  const [isContinue, setIsContinue] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [countDown, setCountDown] = useState(30);

  useEffect(() => {
    props.isToggle(isOpen);
    const timeout = setTimeout(() => {
      if (!isContinue) {
        window.localStorage.clear();
        history.push('/');
        setIsOpen(false);
      }
    }, 30000);
    return () => clearTimeout(timeout);
  }, [isContinue, isOpen, history, props]);

  useEffect(() => {
    if (countDown > 0) {
      const interval = setInterval(() => {
        setCountDown(countDown - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [countDown]);

  const Continue = () => {
    setIsContinue(true);
    setIsOpen(false);
  };

  const Close = () => {
    setIsContinue(false);
    setIsOpen(false);
    window.localStorage.clear();
    history.push('/');
  };

  return (
    <Modal show={isOpen} onHide={Close} backdrop="static" keyboard={false}>
      <Modal.Header className='Terms-login'>
        <Modal.Title>Session Timeout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{`The current session is about to expire in ${countDown} sec`}</p>
        <p>{'Would you like to continue the session?'}</p>
        <div className="col-md-12 btns confirmation ">
          <button className="cta-btns" onClick={Continue}>Continue</button>
          <button className="cta-btns" onClick={Close}>Close</button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

SessionConfirmationModal.propTypes = {
  isToggle: PropTypes.func,
};

export default SessionConfirmationModal;
